// Cookie
// 1 Day = 86400
// 1 Week = 604800
// 1 Month = 2592000
// 1 Year = 31536000
const cookieDuration = '604800'; // Duration of the cookie in seconds

const params = ['default=yes']; // Array of paramaters to add when redirecting

const urlParams = new URLSearchParams(
	window.location.search
); // Get URL parameters

const currentURL = window.location.href;
const currentPath = window.location.pathname;
const currentDomain = window.location.hostname;

// Cache DOM elements for better performance
const geolocationDialog = document.getElementById('geolocation-dialog');
const countrySelect = document.getElementById('country-select');
const languageSelect = document.getElementById('language-select');
const languageSection = document.querySelector('.language-section');

// Cache theme redirect values to avoid repeated Object.values() calls
let themeRedirectValues = null;
function getThemeRedirectValues() {
	if (!themeRedirectValues && window.theme?.redirect) {
		themeRedirectValues = Object.values(window.theme.redirect);
	}
	return themeRedirectValues || [];
}

// Debounce function for performance optimization
function debounce(func, wait) {
	let timeout;
	return function executedFunction(...args) {
		const later = () => {
			clearTimeout(timeout);
			func(...args);
		};
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
	};
}

// Cleanup function to prevent memory leaks
function cleanup() {
	// Clear any pending timeouts
	if (window.geolocationTimeouts) {
		window.geolocationTimeouts.forEach(timeout => clearTimeout(timeout));
		window.geolocationTimeouts = [];
	}
	
	// Reset cached values
	themeRedirectValues = null;
}

// Add cleanup on page unload
window.addEventListener('beforeunload', cleanup);

/**
 * Adds a cookie with the specified duration to the document if one does not already exist
 */
function addCookie(cookieDuration) {
	if (!document.cookie.includes('popupClosed=true')) {
		document.cookie = `popupClosed=true; max-age=${cookieDuration}`;
	}
}

const userAgent = navigator.userAgent;

const googleAdsBotUserAgents = [
	'AdsBot-Google (+http://www.google.com/adsbot.html)',
	'AdsBot-Google-Mobile (+http://www.google.com/mobile/adsbot.html)',
	'AdsBot-Google-Mobile-Apps',
];

// Language mapping for display names and country codes
const languageMap = {
	'en': { name: 'English', countryCode: 'US' },
	'de': { name: 'Deutsch', countryCode: 'DE' },
	'fr': { name: 'Français', countryCode: 'FR' },
	'it': { name: 'Italiano', countryCode: 'IT' },
	'es': { name: 'Español', countryCode: 'ES' },
	'pt': { name: 'Português', countryCode: 'PT' },
	'pl': { name: 'Polski', countryCode: 'PL' },
	'nl': { name: 'Nederlands', countryCode: 'NL' },
	'cs': { name: 'Čeština', countryCode: 'CZ' }
};

/**
 * Returns the flag HTML for the given country code (matching icon-country snippet)
 */
function getFlagHTML(countryCode) {
	const flagMap = {
		'US': '<svg width="26" height="17" viewBox="0 0 26 17" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_18_236)"><path d="M0.884766 0.296875H25.8848V16.2971H0.884766V0.296875Z" fill="white"/><path d="M14.9473 0.296753H11.8223V6.79673H0.884766V9.79673H11.8223V16.2967H14.9473V9.79673H25.8848V6.79673H14.9473V0.296753Z" fill="#D80027"/><path d="M20.1125 11.0793L25.8847 14.1579V11.0793H20.1125ZM16.1021 11.0793L25.8847 16.2967V14.8213L18.8684 11.0793H16.1021ZM23.2789 16.2967L16.1021 12.4687V16.2967H23.2789Z" fill="#0052B4"/><path d="M16.1021 11.0793L25.8847 16.2967V14.8213L18.8684 11.0793H16.1021Z" fill="white"/><path d="M16.1021 11.0793L25.8847 16.2967V14.8213L18.8684 11.0793H16.1021Z" fill="#D80027"/><path d="M5.29595 11.0792L0.884766 13.4319V11.0792H5.29595ZM10.6674 11.7427V16.2967H2.12944L10.6674 11.7427Z" fill="#0052B4"/><path d="M7.90102 11.0793L0.884766 14.8213V16.2967L10.6674 11.0793H7.90102Z" fill="#D80027"/><path d="M6.65698 5.51413L0.884766 2.43557V5.51413H6.65698ZM10.6674 5.51413L0.884766 0.296753V1.7721L7.90102 5.51413H10.6674ZM3.49053 0.296753L10.6674 4.12476V0.296753H3.49053Z" fill="#0052B4"/><path d="M10.6674 5.51413L0.884766 0.296753V1.7721L7.90102 5.51413H10.6674Z" fill="white"/><path d="M10.6674 5.51413L0.884766 0.296753V1.7721L7.90102 5.51413H10.6674Z" fill="#D80027"/><path d="M21.4735 5.51418L25.8847 3.16152V5.51418H21.4735ZM16.1021 4.85071V0.296753H24.64L16.1021 4.85071Z" fill="#0052B4"/><path d="M18.8684 5.51413L25.8847 1.7721V0.296753L16.1021 5.51413H18.8684Z" fill="#D80027"/></g><defs><clipPath id="clip0_18_236"><rect width="25" height="16" fill="white" transform="translate(0.884766 0.296875)"/></clipPath></defs></svg>',
		'DE': '<svg width="26" height="17" viewBox="0 0 26 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.884766 0.296875H25.8848V5.63021H0.884766V0.296875Z" fill="#000000"/><path d="M0.884766 5.63021H25.8848V10.9635H0.884766V5.63021Z" fill="#DD0000"/><path d="M0.884766 10.9635H25.8848V16.2969H0.884766V10.9635Z" fill="#FFCE00"/></svg>',
		'FR': '<svg width="26" height="17" viewBox="0 0 26 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.884766 0.296875H8.88477V16.2969H0.884766V0.296875Z" fill="#002395"/><path d="M8.88477 0.296875H17.8848V16.2969H8.88477V0.296875Z" fill="#FFFFFF"/><path d="M17.8848 0.296875H25.8848V16.2969H17.8848V0.296875Z" fill="#ED2939"/></svg>',
		'IT': '<svg width="26" height="17" viewBox="0 0 26 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.884766 0.296875H8.88477V16.2969H0.884766V0.296875Z" fill="#009246"/><path d="M8.88477 0.296875H17.8848V16.2969H8.88477V0.296875Z" fill="#FFFFFF"/><path d="M17.8848 0.296875H25.8848V16.2969H17.8848V0.296875Z" fill="#CE2B37"/></svg>',
		'ES': '<svg width="26" height="17" viewBox="0 0 26 17" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_18_211)"><path d="M0.884766 0.308105H25.836V16.3081H0.884766V0.308105Z" fill="white"/><path d="M0.884766 0.308105H25.836V4.57478H0.884766V0.308105ZM0.884766 12.0414H25.836V16.3081H0.884766V12.0414Z" fill="#D03433"/><path d="M0.884766 4.56543H25.836V12.0508H0.884766V4.56543Z" fill="#FBCA46"/><path d="M9.53467 7.77478H10.6436V8.30811H9.53467V7.77478Z" fill="white"/><path d="M8.86898 9.37479C8.86898 9.69479 9.20166 9.90812 9.53435 9.90812C9.86703 9.90812 10.1997 9.69479 10.1997 9.37479L10.3106 7.77479H8.75809L8.86898 9.37479ZM8.20361 7.77479C8.20361 7.45479 8.4254 7.24146 8.64719 7.24146H10.3106C10.6433 7.24146 10.8651 7.45479 10.8651 7.66812V7.77479L10.7542 9.37479C10.6433 10.0148 10.1997 10.4415 9.53435 10.4415C8.86898 10.4415 8.4254 10.0148 8.31451 9.37479L8.20361 7.77479Z" fill="#A41517"/><path d="M8.42562 8.30812H10.6435V8.84145H10.089L9.53457 9.90812L8.9801 8.84145H8.42562V8.30812ZM6.76221 6.70812H7.87115V10.4415H6.76221V6.70812ZM11.198 6.70812H12.3069V10.4415H11.198V6.70812ZM8.42562 6.17478C8.42562 5.85478 8.64741 5.64145 8.9801 5.64145H10.089C10.4217 5.64145 10.6435 5.85478 10.6435 6.17478V6.38812C10.6435 6.60145 10.5326 6.70812 10.3108 6.70812H8.64741C8.53652 6.70812 8.42562 6.60145 8.42562 6.49478V6.17478Z" fill="#A41517"/></g><defs><clipPath id="clip0_18_211"><rect width="25" height="16" fill="white" transform="translate(0.884766 0.296875)"/></clipPath></defs></svg>',
		'PT': '<svg width="26" height="17" viewBox="0 0 26 17" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_18_221)"><path d="M0.884766 0.297058H25.8848V16.2967H0.884766V0.297058Z" fill="#D80027"/><path d="M10.4864 0.297058V16.2967H0.884766V0.297058H10.4864Z" fill="#6DA544"/><path d="M10.4863 11.2969C12.2122 11.2969 13.6113 9.95376 13.6113 8.29691C13.6113 6.64005 12.2122 5.29691 10.4863 5.29691C8.76044 5.29691 7.36133 6.64005 7.36133 8.29691C7.36133 9.95376 8.76044 11.2969 10.4863 11.2969Z" fill="#FFDA44"/><path d="M8.72852 6.79691V8.67195C8.72852 9.60392 9.51553 10.3595 10.4863 10.3595C11.4571 10.3595 12.2441 9.60392 12.2441 8.67195V6.79691H8.72852Z" fill="#D80027"/><path d="M10.4863 9.23441C10.1632 9.23441 9.90039 8.98208 9.90039 8.67191V7.92191H11.0723V8.67191C11.0723 8.98203 10.8094 9.23441 10.4863 9.23441Z" fill="white"/></g><defs><clipPath id="clip0_18_221"><rect width="25" height="16" fill="white" transform="translate(0.884766 0.296875)"/></clipPath></defs></svg>',
		'PL': '<svg width="26" height="17" viewBox="0 0 26 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.884766 0.296875H25.8848V8.29688H0.884766V0.296875Z" fill="#FFFFFF"/><path d="M0.884766 8.29688H25.8848V16.2969H0.884766V8.29688Z" fill="#DC143C"/></svg>',
		'NL': '<svg width="26" height="17" viewBox="0 0 26 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.884766 0.296875H25.8848V5.29688H0.884766V0.296875Z" fill="#AE1C28"/><path d="M0.884766 5.29688H25.8848V10.2969H0.884766V5.29688Z" fill="#FFFFFF"/><path d="M0.884766 10.2969H25.8848V15.2969H0.884766V10.2969Z" fill="#21468B"/></svg>',
		'CZ': '<svg width="26" height="17" viewBox="0 0 26 17" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_cz_flag)"><rect x="0" y="8.5" width="26" height="8.5" fill="#D72027"/><rect x="0" y="0" width="26" height="8.5" fill="white"/><polygon points="13 8.5 0 0 0 17 13 8.5" fill="#16467D"/></g><defs><clipPath id="clip0_cz_flag"><rect width="26" height="17" fill="white"/></clipPath></defs></svg>'
	};
	
	// Handle case-insensitive lookup
	const normalizedCode = countryCode ? countryCode.toUpperCase() : '';
	return flagMap[normalizedCode] || flagMap[countryCode] || '';
}

/**
 * Renders a flag SVG for the given country code using the existing icon-country snippet
 */
function renderFlag(svgElement, countryCode) {
	svgElement.innerHTML = getFlagHTML(countryCode);
}

/**
 * Updates language section based on whether country uses path prefixes
 */
function updateLanguageSection(usesPathPrefix, languagesString, countryCode = 'EU') {
	if (!languageSection || !languageSelect) return;
	
	if (usesPathPrefix) {
		// Show language section
		languageSection.removeAttribute('aria-disabled');
		languageSection.style.removeProperty('display');
		languageSection.style.opacity = '1';
		languageSection.style.pointerEvents = 'auto';
		languageSelect.style.pointerEvents = 'auto';
		languageSelect.style.opacity = '1';
		
		// Update language options
		updateLanguageOptions(languagesString, countryCode);
	} else {
		// No language choice for this country — hide the whole block
		languageSection.removeAttribute('aria-disabled');
		languageSection.style.display = 'none';
		
		// Clear language options
		const languageOptions = document.getElementById('language-options');
		if (languageOptions) {
			languageOptions.innerHTML = '';
		}
		
		// Reset trigger display
		const textElement = languageSelect.querySelector('.select-text');
		const flagContainer = languageSelect.querySelector('.flag-container');
		if (textElement) textElement.textContent = 'Language';
		if (flagContainer) flagContainer.innerHTML = '';
	}
}

/**
 * Intelligently selects the best language based on navigator.language and available options
 */
function selectBestLanguage(availableLanguages, countryCode) {
	
	// Get the user's preferred languages from navigator
	const userLanguages = navigator.languages || [navigator.language];
	
	// Try to find an exact match first
	for (const userLang of userLanguages) {
		const langCode = userLang.split('-')[0].toLowerCase(); // e.g., 'en-UK' -> 'en'
		if (availableLanguages.includes(langCode)) {
			return langCode;
		}
	}
	
	// Try to find a partial match (e.g., 'en-UK matches 'en')
	for (const userLang of userLanguages) {
		const langCode = userLang.split('-')[0].toLowerCase();
		const partialMatch = availableLanguages.find(lang => 
			lang.toLowerCase().startsWith(langCode) || langCode.startsWith(lang.toLowerCase())
		);
		if (partialMatch) {
			return partialMatch;
		}
	}
	
	// Fallback to country-specific defaults
	const countryDefaults = {
		'CH': 'de', // Switzerland -> German
		'DE': 'de', // Germany -> German
		'AT': 'de', // Austria -> German
		'FR': 'fr', // France -> French
		'ES': 'es', // Spain -> Spanish
		'IT': 'it', // Italy -> Italian
		'PT': 'pt', // Portugal -> Portuguese
		'PL': 'pl', // Poland -> Polish
		'BE': 'nl', // Belgium -> Dutch
		'NL': 'nl', // Netherlands -> Dutch
		'CZ': 'cs', // Czech Republic -> Czech
		'US': 'en', // US -> English
		'GB': 'en', // UK -> English
		'EU': 'en'  // Europe -> English
	};
	
	const defaultLang = countryDefaults[countryCode] || 'en';
	
	// Make sure the default is available
	if (availableLanguages.includes(defaultLang)) {
		return defaultLang;
	}
	
	// Last resort: use the first available language
	return availableLanguages[0];
}

/**
 * Updates language options based on selected country
 */
function updateLanguageOptions(languagesString, countryCode = 'EU') {
	const languageSelect = document.getElementById('language-select');
	const languageOptions = document.getElementById('language-options');
	
	if (!languageSelect || !languageOptions) return;
	
	// Clear existing options
	languageOptions.innerHTML = '';
	
	// Parse languages string (e.g., "en,de,fr")
	const languages = languagesString.split(',').map(lang => lang.trim()).filter(lang => lang.length > 0);
	
		// Select the best language based on user preferences
		const selectedLanguage = selectBestLanguage(languages, countryCode || 'EU');
	
	// Create language options
	languages.forEach((lang, index) => {
		// Normalize language code to lowercase for lookup
		const normalizedLang = lang.trim().toLowerCase();
		const langData = languageMap[normalizedLang] || languageMap[lang];
		
		// Debug logging (can be removed later)
		if (normalizedLang === 'cs') {
			console.log('Czech language found:', { lang, normalizedLang, langData, countryCode: langData?.countryCode });
		}
		if (langData) {
			const option = document.createElement('li');
			option.className = 'custom-select-option';
			option.setAttribute('role', 'option');
			option.setAttribute('data-value', lang);
			option.setAttribute('data-country-code', langData.countryCode);
			if (lang === selectedLanguage || normalizedLang === selectedLanguage) {
				option.setAttribute('aria-selected', 'true');
			}
			
			// Generate flag HTML first
			const flagHTML = getFlagHTML(langData.countryCode);
			
			option.innerHTML = `
				<div class="flag-container">
					${flagHTML || ''}
				</div>
				<span>${langData.name}</span>
			`;
			
			languageOptions.appendChild(option);
		}
	});
	
	// Update the trigger display to show selected language
	if (languages.length > 0) {
		const normalizedSelectedLang = selectedLanguage.trim().toLowerCase();
		const selectedLangData = languageMap[normalizedSelectedLang] || languageMap[selectedLanguage];
		if (selectedLangData) {
			const textElement = languageSelect.querySelector('.select-text');
			const flagContainer = languageSelect.querySelector('.flag-container');
			
			textElement.textContent = selectedLangData.name;
			const flagHTML = getFlagHTML(selectedLangData.countryCode);
			if (flagHTML) {
				flagContainer.innerHTML = flagHTML;
			}
		}
	}
	
	// Reinitialize the custom select for the language dropdown
	const customSelect = languageSelect.closest('.custom-select');
	if (customSelect) {
		// Remove existing event listeners and reinitialize
		const newCustomSelect = new CustomSelect(customSelect);
	}
}

/**
 * Shows the geolocation popup manually (for globe icon click)
 */
function showGeolocationPopup() {
	if (geolocationDialog) {
		showLocationPopup(window.theme.redirect.uk); // Default to UK
	}
}

/**
 * Checks if the current URL matches the target URL (handles both domain and path-based URLs)
 * Also handles language variations for countries that support multiple languages
 */
function isCurrentUrl(redirectUrl, countryTheme = null) {
	if (redirectUrl.startsWith('http')) {
		// Domain-based URL (e.g., https://corston.com)
		return currentURL.startsWith(redirectUrl);
	} else {
		// Path-based URL (e.g., /fr-fr)
		// Check if we're on the exact path
		if (currentPath.startsWith(redirectUrl)) {
			return true;
		}
		
		// For countries with multiple languages, check if we're on a language variant
		if (countryTheme && countryTheme.languages && countryTheme.languages.length > 1) {
			// Extract the country code from the redirect URL (e.g., "ch" from "/de-ch")
			const countryCode = redirectUrl.split('-').pop();
			
			// Check if current path matches any language variant for this country
			for (const language of countryTheme.languages) {
				const languageVariant = `/${language}-${countryCode}`;
				if (currentPath.startsWith(languageVariant)) {
					return true;
				}
			}
		}
		
		return false;
	}
}

/**
 * Redirects the current page to the specified URL if certain conditions are met.
 */
function autoRedirect(redirectUrl, countryTheme = null) {
	if (
		!isCurrentUrl(redirectUrl, countryTheme) &&
		currentURL.includes('corston.')
	) {
		window.location.href = `${redirectUrl}/?${params.join(
			'&'
		)}`;
	}
}

/**
 * Displays a location popup with geolocation options.
 */
function showLocationPopup(countryTheme) {
	const submitBtn = document.getElementById('submit-btn');
	// remember last language explicitly chosen by user within this popup session
	let lastSelectedLanguage = '';

	const supportUrl = () => {
		// Check if the current URL contains any of the following paths and return the path in the redirect
		if (currentURL.includes('/pages/support')) {
			return 'pages/support/';
		} else if (currentURL.includes('/pages/environmental-policy')) {
			return 'pages/environmental-policy';
		} else {
			return '';
		}
	};

	// Set initial country selection
	// Try to find the country option by matching the country theme with HTML options
	let countryOption = null;
	
	// First try to find by exact label match
	countryOption = countrySelect.querySelector(`[data-value="${countryTheme.label}"]`);
	
	// If not found, try to find by country code
	if (!countryOption && countryTheme.countries && countryTheme.countries.length > 0) {
		const countryCode = countryTheme.countries[0].toUpperCase();
		countryOption = countrySelect.querySelector(`[data-country-code="${countryCode}"]`);
	}
	
	// If still not found, try to find by URL match
	if (!countryOption) {
		countryOption = countrySelect.querySelector(`[data-url="${countryTheme.url}"]`);
	}
	
	
	if (countryOption) {
		// Update the country select trigger display
		const countryTrigger = countrySelect.querySelector('.custom-select-trigger');
		const countryText = countryTrigger.querySelector('.select-text');
		const countryFlag = countryTrigger.querySelector('.flag-container');
		
		// Update the display text
		countryText.textContent = countryOption.getAttribute('data-value');
		
		// Update the flag
		const countryCode = countryOption.dataset.countryCode || countryOption.dataset.country_code;
		if (countryCode && countryFlag) {
			countryFlag.innerHTML = getFlagHTML(countryCode);
		}
		
		// Set aria-selected attributes
		countrySelect.querySelectorAll('.custom-select-option').forEach(option => {
			option.setAttribute('aria-selected', 'false');
		});
		countryOption.setAttribute('aria-selected', 'true');
		
		// Trigger the click to update the custom select state
		countryOption.click();
		
		// Update language section based on the selected country
		const selectedCountry = countryOption.dataset.url;
		
		
		// Get languages from theme.redirect object instead of data-languages attribute
		let languages = 'en'; // Default fallback
		if (countryCode) {
			// First try to find by country code in countries array
			let countryTheme = getThemeRedirectValues().find(item => 
				item.countries.includes(countryCode.toLowerCase())
			);
			
			// If not found, try to find by region key (for special cases like Europe)
			if (!countryTheme) {
				countryTheme = window.theme.redirect[countryCode.toLowerCase()];
			}
			
			languages = countryTheme ? countryTheme.languages.join(',') : 'en';
		}
		
		// Check if country uses path prefix system
		// Europe is special - it should show all languages
		const isEurope = countryCode === 'EU' || countryCode === 'eu' || selectedCountry.includes('corston.eu');
		const usesPathPrefix = selectedCountry.startsWith('/') || isEurope;

		// Update language section based on path prefix usage
		updateLanguageSection(usesPathPrefix, languages, countryCode);
	} else {
		// Fallback: Initialize language section (EU uses path prefixes, so enable)
		updateLanguageSection(true, 'en', countryCode);
	}

	// Update shop now button href when country select is changed
	countrySelect.addEventListener('change', function (e) {
		const selectedCountry = e.detail.url;
		const countryCode = e.detail.country_code;
		
		// Get languages from theme.redirect object instead of data-languages attribute
		let languages = 'en'; // Default fallback
		if (countryCode) {
			// First try to find by country code in countries array
			let countryTheme = getThemeRedirectValues().find(item => 
				item.countries.includes(countryCode.toLowerCase())
			);
			
			// If not found, try to find by region key (for special cases like Europe)
			if (!countryTheme) {
				countryTheme = window.theme.redirect[countryCode.toLowerCase()];
			}
			
			languages = countryTheme ? countryTheme.languages.join(',') : 'en';
		}
		
		// Check if country uses path prefix system
		// Europe is special - it should show all languages
		const isEurope = countryCode === 'EU' || countryCode === 'eu' || selectedCountry.includes('corston.eu');
		const usesPathPrefix = selectedCountry.startsWith('/') || isEurope;
		
		// Update language section based on path prefix usage
		updateLanguageSection(usesPathPrefix, languages, countryCode);
		
		updateShopNowHref(selectedCountry);
	});

	// Update shop now button href when language select is changed
	languageSelect.addEventListener('change', function (e) {
		// capture selected language immediately
		const opt = languageSelect.querySelector('.custom-select-options .custom-select-option[aria-selected="true"]') || languageSelect.querySelector('.custom-select-options .custom-select-option.selected');
		if (opt && opt.dataset && opt.dataset.value) {
			lastSelectedLanguage = opt.dataset.value;
		}
		const selectedCountryOption = countrySelect.querySelector('[aria-selected="true"]') || countrySelect.querySelector('.custom-select-option.selected');
		if (selectedCountryOption) {
			const selectedCountry = selectedCountryOption.dataset.url;
			updateShopNowHref(selectedCountry);
		}
	});

	// Also update when a language option is clicked (some custom selects don't emit change)
	languageSelect.addEventListener('click', function (e) {
		const option = e.target.closest('.custom-select-option');
		if (!option) return;
		if (option && option.dataset && option.dataset.value) {
			lastSelectedLanguage = option.dataset.value;
		}
		const selectedCountryOption = countrySelect.querySelector('[aria-selected="true"]') || countrySelect.querySelector('.custom-select-option.selected');
		if (selectedCountryOption) {
			const selectedCountry = selectedCountryOption.dataset.url;
			updateShopNowHref(selectedCountry);
		}
	});

	// Extra: click listener on the options list to guarantee capture
	const languageOptionsList = document.getElementById('language-options');
	if (languageOptionsList) {
		languageOptionsList.addEventListener('click', function (e) {
			const option = e.target.closest('.custom-select-option');
			if (!option) return;
			if (option && option.dataset && option.dataset.value) {
				lastSelectedLanguage = option.dataset.value;
			}
			const selectedCountryOption = countrySelect.querySelector('[aria-selected="true"]') || countrySelect.querySelector('.custom-select-option.selected');
			if (selectedCountryOption) {
				const selectedCountry = selectedCountryOption.dataset.url;
				updateShopNowHref(selectedCountry);
			}
		});
	}

	// Helper: build EU base URL from language
	const buildEu = (lang) => lang && lang !== 'en' ? `https://corston.eu/${lang}` : 'https://corston.eu';

	// Helper: compute final URL from country URL and language code
	function computeFinalUrl(countryUrl, langCode) {
		let finalUrl = countryUrl;
		try {
			if (countryUrl.startsWith('http')) {
				const u = new URL(countryUrl);
				const isEuDomain = u.hostname.includes('corston.eu');
				const path = u.pathname || '/';
				const match = path.match(/^\/(\w{2})-([A-Za-z]{2})/i);
				if (isEuDomain) {
					if (match) {
						const countryCode = match[2].toLowerCase();
						finalUrl = `https://corston.eu/${langCode}-${countryCode}`;
					} else if (path === '/' || path === '') {
						finalUrl = buildEu(langCode);
					} else if (/^\/[a-z]{2}-eu(\/|$)/i.test(path)) {
						finalUrl = buildEu(langCode);
					} else {
						finalUrl = buildEu(langCode);
					}
				} else {
					finalUrl = countryUrl;
				}
			} else {
				if (countryUrl === '/') {
					finalUrl = buildEu(langCode);
				} else {
					const pathParts = countryUrl.split('/');
					const existingPrefix = pathParts[1] || '';
					const prefixParts = existingPrefix.split('-');
					const countryCode = (prefixParts[1] || prefixParts[0] || '').toLowerCase();
					if (countryCode === 'eu' || countryCode === '') {
						finalUrl = buildEu(langCode);
					} else {
						const newPrefix = `${langCode}-${countryCode}`;
						pathParts[1] = newPrefix;
						finalUrl = `https://corston.eu${pathParts.join('/')}`;
					}
				}
			}
		} catch (e) {
		}
		return finalUrl;
	}

	// Function to update the shop now button href
	function updateShopNowHref(countryUrl) {
		const selectedLanguageOption = languageSelect.querySelector('.custom-select-options .custom-select-option[aria-selected="true"]') || languageSelect.querySelector('.custom-select-options .custom-select-option.selected');
		let selectedLanguage = lastSelectedLanguage || (selectedLanguageOption ? selectedLanguageOption.dataset.value : '');
		
		// Fallback: derive from trigger display text if needed
		if (!selectedLanguage) {
			const trigger = languageSelect.querySelector('.custom-select-trigger .select-text');
			const displayText = trigger ? trigger.textContent.trim() : '';
			const nameToCode = {
				'English': 'en',
				'Deutsch': 'de',
				'Français': 'fr',
				'Italiano': 'it',
				'Español': 'es',
				'Português': 'pt',
				'Polski': 'pl',
				'Nederlands': 'nl',
				'Čeština': 'cs'
			};
			selectedLanguage = nameToCode[displayText] || 'en';
		}
		
		// For visibility in logs, compute preview URL but do not bind stale value
		const previewUrl = computeFinalUrl(countryUrl, selectedLanguage);
		// Persist preview URL so click uses exactly what user sees
		submitBtn.dataset.finalUrl = previewUrl;
		
		// Ensure only our navigation runs
		submitBtn.addEventListener('click', function(e) {
			e.preventDefault();
			e.stopImmediatePropagation();
			const persisted = submitBtn.dataset.finalUrl;
			let navUrl = persisted && persisted.startsWith('http') ? persisted : '';
			if (!navUrl) {
				// Recompute current selections at click time as a fallback
				const currentCountryOption = countrySelect.querySelector('[aria-selected="true"]') || countrySelect.querySelector('.custom-select-option.selected');
				const currentCountryUrl = currentCountryOption ? currentCountryOption.dataset.url : countryUrl;
				let lang = lastSelectedLanguage;
				if (!lang) {
					const langOpt = languageSelect.querySelector('.custom-select-options .custom-select-option[aria-selected="true"]') || languageSelect.querySelector('.custom-select-options .custom-select-option.selected');
					if (langOpt) lang = langOpt.dataset.value;
				}
				if (!lang) {
					const trig = languageSelect.querySelector('.custom-select-trigger .select-text');
					const txt = trig ? trig.textContent.trim() : '';
					const nameToCode2 = { 'English': 'en', 'Deutsch': 'de', 'Français': 'fr', 'Italiano': 'it', 'Español': 'es', 'Português': 'pt', 'Polski': 'pl', 'Nederlands': 'nl', 'Čeština': 'cs' };
					lang = nameToCode2[txt] || 'en';
				}
				navUrl = computeFinalUrl(currentCountryUrl, lang);
			}
			const dest = `${navUrl}/${supportUrl()}?${params.join('&')}`;
			// Delay a tick to ensure no other handlers override
			setTimeout(() => { window.location.href = dest; }, 0);
			addCookie(cookieDuration);
		}, { passive: false });
	}

	// Set initial href
	updateShopNowHref(countryTheme.url);

	// Show the geolocation dialog
	geolocationDialog.style.display = 'flex';

	// Add 'no-scroll' class to body to prevent scrolling while the popup is active
	document.body.classList.add('no-scroll');
	
	// Block all body interactions except the popup
	document.body.style.pointerEvents = 'none';
	geolocationDialog.style.pointerEvents = 'auto';
	
	// Ensure popup can receive focus
	geolocationDialog.setAttribute('tabindex', '-1');
	
	// Set up focus trap first, then focus the popup
	setupFocusTrap();
	
	// Focus the first select directly instead of the popup
	setTimeout(() => {
		const firstSelect = geolocationDialog.querySelector('.custom-select');
		if (firstSelect) {
			const trigger = firstSelect.querySelector('.custom-select-trigger');
			if (trigger) {
				trigger.focus();
			}
		}
	}, 100);
}

/**
 * Change the United Kingdom option to International for users outside Europe
 */
function setInternationalPopup() {
	
	// Use EU theme for international users
	const ukTheme = window.theme.redirect.uk;
	if (ukTheme) {
		showLocationPopup(ukTheme);
	} else {
		showLocationPopup(ukTheme);
	}
}

// Flag to prevent multiple geolocation calls
let geolocationInProgress = false;

/**
 * Retrieves the user's country information and performs actions based on the country and response status.
 */
async function getCountry() {
	
	// Prevent multiple simultaneous calls
	if (geolocationInProgress) {
		return;
	}
	
	geolocationInProgress = true;
	
	try {
		// Try multiple geolocation APIs for better VPN support
		let data = null;
		let response = null;
		
		// Primary API: ipgeolocation.io
		try {
			response = await fetch(
				'https://api.ipgeolocation.io/ipgeo?apiKey=5acf21b7bc0f4238b6e885d4ffe0d88f&fields=country_code2,is_eu'
			);
			data = await response.json();
	} catch (primaryError) {
	}
	
	// Fallback API: ipapi.co (better VPN support)
	if (!data || !data.country_code2) {
		try {
			const fallbackResponse = await fetch('https://ipapi.co/json/');
			const fallbackData = await fallbackResponse.json();
				
				if (fallbackData.country_code) {
					data = {
						country_code2: fallbackData.country_code,
						is_eu: fallbackData.in_eu || false
					};
					response = { status: 200 };
				}
			} catch (fallbackError) {
			}
		}

		if (response.status === 200) {
			
			// Find the country object which contains the users country code
			const countryTheme = getThemeRedirectValues().find(item => {
				return item.countries.includes(data.country_code2.toLowerCase());
			});
			
			// If no theme found by countries array, try direct key lookup
			let finalCountryTheme = countryTheme;
			if (!countryTheme) {
				const directKey = data.country_code2.toLowerCase();
				finalCountryTheme = theme.redirect[directKey];
			}

			if (finalCountryTheme) {
				switch (finalCountryTheme.type) {
					case 'auto-redirect':
						autoRedirect(finalCountryTheme.url);
						break;
					case 'popup':
						if (!isCurrentUrl(finalCountryTheme.url)) {
							showLocationPopup(finalCountryTheme);
						}
						break;
					case 'no-redirect':
						addCookie(cookieDuration);
						break;
				}
			} else if (
				!data.is_eu &&
				!isCurrentUrl('https://corston.com') &&
				!currentURL.includes('shopify')
			) {
				setInternationalPopup();
			} else if (isCurrentUrl('https://corston.com')) {
				// do nothing
			} else {
				showLocationPopup(theme.redirect.uk);
			}
		} else {

			// Show UK popup as fallback when API returns non-200 status
			if (window.theme?.redirect?.uk) {
				showLocationPopup(window.theme.redirect.uk);
			} else {
				geolocationDialog.style.display = 'flex';
				document.body.classList.add('no-scroll');
			}
		}
	} catch (error) {
		// Show UK popup as fallback when API fails
		if (window.theme?.redirect?.uk) {
			showLocationPopup(window.theme.redirect.uk);
		} else {
			// Basic fallback if theme object isn't ready
			geolocationDialog.style.display = 'flex';
			document.body.classList.add('no-scroll');
		}
	} finally {
		// Reset the flag when done
		geolocationInProgress = false;
	}
}

/**
 * When popup close button is clicked then add a cookie and hide the popup
 */
function closePopup() {
	addCookie(cookieDuration);
	document.body.classList.remove('no-scroll');
	document.body.style.pointerEvents = '';
	geolocationDialog.style.display = 'none';
	
	// Remove focus trap
	removeFocusTrap();
}

/**
 * Set up focus trap to prevent other elements from taking focus
 */
function setupFocusTrap() {
	// Store original tabindex values
	const originalTabIndexes = new Map();
	
	// Find all focusable elements outside the popup, especially OneTrust elements
	const focusableElements = document.querySelectorAll(
		'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"]), [contenteditable], iframe, embed, object, video, audio, [id*="onetrust"], [class*="onetrust"], [id*="cookie"], [class*="cookie"]'
	);
	
	focusableElements.forEach(element => {
		if (!geolocationDialog.contains(element)) {
			originalTabIndexes.set(element, element.getAttribute('tabindex'));
			element.setAttribute('tabindex', '-1');
			// Disable pointer events to prevent any interaction
			element.style.pointerEvents = 'none';
		}
	});
	
	// Store the original tabindexes for restoration
	window.geolocationOriginalTabIndexes = originalTabIndexes;
	
	// Add event listeners to prevent focus from escaping
	document.addEventListener('focusin', handleFocusIn, true);
	
	// Less aggressive focus monitoring
	const focusInterval = setInterval(() => {
		const activeElement = document.activeElement;
		if (activeElement && !geolocationDialog.contains(activeElement)) {
			// Focus the first select directly
			const firstSelect = geolocationDialog.querySelector('.custom-select');
			if (firstSelect) {
				const trigger = firstSelect.querySelector('.custom-select-trigger');
				if (trigger) {
					trigger.focus();
				}
			}
		}
	}, 200);
	
	window.geolocationFocusInterval = focusInterval;
}

/**
 * Handle focus events to keep focus within the popup
 */
function handleFocusIn(event) {
	// Allow focus within the popup
	if (geolocationDialog.contains(event.target)) {
		return;
	}
	
	// Block focus outside popup (especially OneTrust elements)
	if (event.target.closest('[id*="onetrust"], [class*="onetrust"], [id*="cookie"], [class*="cookie"]')) {
		event.preventDefault();
		event.stopPropagation();
		
		// Focus the first select directly
		const firstSelect = geolocationDialog.querySelector('.custom-select');
		if (firstSelect) {
			const trigger = firstSelect.querySelector('.custom-select-trigger');
			if (trigger) {
				trigger.focus();
			}
		}
	}
}

/**
 * Remove focus trap and restore original tabindex values
 */
function removeFocusTrap() {
	// Remove event listeners
	document.removeEventListener('focusin', handleFocusIn, true);
	
	// Clear focus interval
	if (window.geolocationFocusInterval) {
		clearInterval(window.geolocationFocusInterval);
		window.geolocationFocusInterval = null;
	}
	
	// Restore original tabindex values and pointer events
	if (window.geolocationOriginalTabIndexes) {
		window.geolocationOriginalTabIndexes.forEach((originalTabIndex, element) => {
			if (originalTabIndex === null) {
				element.removeAttribute('tabindex');
			} else {
				element.setAttribute('tabindex', originalTabIndex);
			}
			// Restore pointer events
			element.style.pointerEvents = '';
		});
		window.geolocationOriginalTabIndexes = null;
	}
}

// Make functions globally available for testing
window.closePopup = closePopup;
window.showGeolocationPopup = showGeolocationPopup;
window.forceShowPopup = () => {
	// Clear any existing popup cookies
	document.cookie = 'popupClosed=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
	// Force show popup
	showLocationPopup(window.theme.redirect.uk);
};

// Debug function to check popup state
window.debugPopup = () => {
};


// Custom Select Component
class CustomSelect {
	constructor(element) {
		this.element = element;
		this.trigger = element.querySelector('.custom-select-trigger');
		this.options = element.querySelectorAll('.custom-select-option');
		this.textElement = element.querySelector('.select-text');
		this.flagElement = element.querySelector('.flag-container');
		this.isOpen = false;
		this.selectedIndex = 0;
		this.focusedIndex = 0;
		this.typeAheadString = '';
		this.typeAheadTimeout = null;
		
		// Store instance on element for reference
		element._customSelectInstance = this;
		
		this.init();
	}
	
	init() {
		// Set initial selection
		this.setInitialSelection();
		
		// Bind events
		this.bindEvents();
		
		// Set ARIA attributes
		this.updateAriaAttributes();
	}
	
	setInitialSelection() {
		const selectedOption = this.element.querySelector('[aria-selected="true"]');
		if (selectedOption) {
			this.selectOption(selectedOption);
		} else if (this.options.length > 0) {
			this.selectOption(this.options[0]);
		}
	}
	
	bindEvents() {
		// Click events
		this.trigger.addEventListener('click', (e) => {
			e.preventDefault();
			e.stopPropagation();
			this.toggle();
		});
		
		// Option click events
		this.options.forEach((option, index) => {
			option.addEventListener('click', (e) => {
				e.preventDefault();
				e.stopPropagation();
				this.selectOption(option);
				this.close();
			});
			
			// Mouse events for hover
			option.addEventListener('mouseenter', () => {
				this.focusedIndex = index;
				this.updateFocus();
			});
		});
		
		// Keyboard events
		this.element.addEventListener('keydown', (e) => {
			this.handleKeydown(e);
		});
		
		// Type-ahead search
		this.element.addEventListener('keypress', (e) => {
			this.handleTypeAhead(e);
		});
		
		// Click outside to close
		document.addEventListener('click', (e) => {
			if (!this.element.contains(e.target)) {
				this.close();
			}
		});
	}
	
	handleKeydown(e) {
		if (!this.isOpen) {
			if (e.key === 'Enter' || e.key === ' ' || e.key === 'ArrowDown' || e.key === 'ArrowUp') {
				e.preventDefault();
				this.open();
			}
			return;
		}
		
		switch (e.key) {
			case 'ArrowDown':
				e.preventDefault();
				this.focusedIndex = Math.min(this.focusedIndex + 1, this.options.length - 1);
				this.updateFocusWithKeyboard();
				break;
			case 'ArrowUp':
				e.preventDefault();
				this.focusedIndex = Math.max(this.focusedIndex - 1, 0);
				this.updateFocusWithKeyboard();
				break;
			case 'Home':
				e.preventDefault();
				this.focusedIndex = 0;
				this.updateFocusWithKeyboard();
				break;
			case 'End':
				e.preventDefault();
				this.focusedIndex = this.options.length - 1;
				this.updateFocusWithKeyboard();
				break;
			case 'Enter':
			case ' ':
				e.preventDefault();
				this.selectOption(this.options[this.focusedIndex]);
				this.close();
				break;
			case 'Escape':
				e.preventDefault();
				this.close();
				break;
			case 'Tab':
				if (this.isOpen) {
					e.preventDefault();
					if (e.shiftKey) {
						// Shift+Tab: go to previous option or close if at first
						if (this.focusedIndex > 0) {
							this.focusedIndex--;
							this.updateFocusWithKeyboard();
						} else {
							this.close();
						}
					} else {
						// Tab: go to next option or close if at last
						if (this.focusedIndex < this.options.length - 1) {
							this.focusedIndex++;
							this.updateFocusWithKeyboard();
						} else {
							this.close();
						}
					}
				} else {
					this.close();
				}
				break;
		}
	}
	
	toggle() {
		if (this.isOpen) {
			this.close();
		} else {
			this.open();
		}
	}
	
	open() {
		// Close all other custom selects first
		this.closeOtherSelects();
		
		this.isOpen = true;
		this.element.setAttribute('aria-expanded', 'true');
		this.focusedIndex = this.selectedIndex;
		this.updateFocus();
		this.announce('List opened');
		
		// Ensure the first option can be focused with Tab
		if (this.options.length > 0) {
			this.options[0].setAttribute('tabindex', '0');
		}
		
		// Apply proper z-index stacking for location vs language select
		this.applyZIndexStacking();
		
		// Focus the trigger to ensure keyboard navigation works
		this.trigger.focus();
	}
	
	close() {
		this.isOpen = false;
		this.element.setAttribute('aria-expanded', 'false');
		
		// Reset z-index stacking when closing
		this.resetZIndexStacking();
		
		this.trigger.focus();
	}
	
	applyZIndexStacking() {
		// If this is the country select, ensure its options appear above language select
		if (this.element.id === 'country-select') {
			const options = this.element.querySelector('.custom-select-options');
			if (options) {
				options.style.zIndex = '1001';
			}
			
			// Lower the language select z-index
			const languageSelect = document.getElementById('language-select');
			if (languageSelect) {
				languageSelect.style.zIndex = '999';
				const languageOptions = languageSelect.querySelector('.custom-select-options');
				if (languageOptions) {
					languageOptions.style.zIndex = '999';
				}
			}
		}
		// If this is the language select, ensure it has lower z-index than country select
		else if (this.element.id === 'language-select') {
			const options = this.element.querySelector('.custom-select-options');
			if (options) {
				options.style.zIndex = '999';
			}
			
			// Ensure country select options have higher z-index if they're open
			const countrySelect = document.getElementById('country-select');
			if (countrySelect && countrySelect.getAttribute('aria-expanded') === 'true') {
				const countryOptions = countrySelect.querySelector('.custom-select-options');
				if (countryOptions) {
					countryOptions.style.zIndex = '1001';
				}
			}
		}
	}
	
	resetZIndexStacking() {
		// Reset z-index values to default
		const options = this.element.querySelector('.custom-select-options');
		if (options) {
			options.style.zIndex = '';
		}
		
		// Reset language select z-index
		const languageSelect = document.getElementById('language-select');
		if (languageSelect) {
			languageSelect.style.zIndex = '';
			const languageOptions = languageSelect.querySelector('.custom-select-options');
			if (languageOptions) {
				languageOptions.style.zIndex = '';
			}
		}
		
		// Reset country select z-index
		const countrySelect = document.getElementById('country-select');
		if (countrySelect) {
			countrySelect.style.zIndex = '';
			const countryOptions = countrySelect.querySelector('.custom-select-options');
			if (countryOptions) {
				countryOptions.style.zIndex = '';
			}
		}
	}
	
	closeOtherSelects() {
		// Find all other geolocation custom selects and close them
		const allSelects = document.querySelectorAll('#geolocation-dialog .custom-select');
		allSelects.forEach(select => {
			if (select !== this.element) {
				// Find the CustomSelect instance for this element
				const customSelectInstance = select._customSelectInstance;
				if (customSelectInstance && customSelectInstance.isOpen) {
					customSelectInstance.close();
				}
			}
		});
	}
	
	selectOption(option) {
		// Remove previous selection
		this.options.forEach(opt => opt.removeAttribute('aria-selected'));
		
		// Set new selection
		option.setAttribute('aria-selected', 'true');
		this.selectedIndex = Array.from(this.options).indexOf(option);
		this.focusedIndex = this.selectedIndex;
		
		// Update display
		const text = option.querySelector('span').textContent;
		const flagContainer = option.querySelector('.flag-container');
		
		this.textElement.textContent = text;
		this.flagElement.innerHTML = flagContainer.innerHTML;
		
		// Trigger change event
		this.element.dispatchEvent(new CustomEvent('change', {
			detail: {
				value: option.dataset.value,
				url: option.dataset.url,
				country_code: option.dataset.countryCode,
				languages: option.dataset.languages
			}
		}));
		
		this.announce(`Selected ${text}`);
	}
	
	updateFocus() {
		// Remove focus from all options
		this.options.forEach(opt => {
			opt.removeAttribute('tabindex');
			opt.classList.remove('focused');
		});
		
		// Set focus to current option
		if (this.options[this.focusedIndex]) {
			const option = this.options[this.focusedIndex];
			option.setAttribute('tabindex', '0');
			option.classList.add('focused');
		}
	}
	
	updateFocusWithKeyboard() {
		// Same as updateFocus but also calls .focus() for keyboard navigation
		this.updateFocus();
		if (this.options[this.focusedIndex]) {
			this.options[this.focusedIndex].focus();
		}
	}
	
	updateAriaAttributes() {
		this.element.setAttribute('aria-expanded', 'false');
		this.options.forEach((option, index) => {
			option.setAttribute('tabindex', index === 0 ? '0' : '-1');
		});
	}
	
	handleTypeAhead(e) {
		if (!this.isOpen) return;
		
		// Clear previous timeout
		if (this.typeAheadTimeout) {
			clearTimeout(this.typeAheadTimeout);
		}
		
		// Add character to type-ahead string
		this.typeAheadString += e.key.toLowerCase();
		
		// Find matching option
		const matchingIndex = this.findMatchingOption(this.typeAheadString);
		if (matchingIndex !== -1) {
			this.focusedIndex = matchingIndex;
			this.updateFocus();
		}
		
		// Clear type-ahead string after 1 second (debounced)
		this.typeAheadTimeout = setTimeout(() => {
			this.typeAheadString = '';
		}, 1000);
	}
	
	findMatchingOption(searchString) {
		for (let i = 0; i < this.options.length; i++) {
			const optionText = this.options[i].querySelector('span').textContent.toLowerCase();
			if (optionText.startsWith(searchString)) {
				return i;
			}
		}
		return -1;
	}
	
	announce(message) {
		// Create or update live region for screen readers
		let liveRegion = document.getElementById('custom-select-live-region');
		if (!liveRegion) {
			liveRegion = document.createElement('div');
			liveRegion.id = 'custom-select-live-region';
			liveRegion.setAttribute('aria-live', 'polite');
			liveRegion.setAttribute('aria-atomic', 'true');
			liveRegion.style.position = 'absolute';
			liveRegion.style.left = '-10000px';
			liveRegion.style.width = '1px';
			liveRegion.style.height = '1px';
			liveRegion.style.overflow = 'hidden';
			document.body.appendChild(liveRegion);
		}
		liveRegion.textContent = message;
	}
}

// Initialize custom selects when DOM is ready
document.addEventListener('DOMContentLoaded', function () {
	// Initialize only geolocation popup custom selects (not product page selects)
	const customSelects = document.querySelectorAll('#geolocation-dialog .custom-select');
	customSelects.forEach(select => {
		new CustomSelect(select);
	});
	
	// Globe icon click handler
	const globeIcon = document.querySelector('.globe-icon');
	if (globeIcon) {
		globeIcon.addEventListener('click', function (e) {
			e.preventDefault();
			showGeolocationPopup();
		});
	}
});

// Development mode - force show popup for testing
const isDevelopment = (window.location.hostname === 'localhost' || 
                     window.location.hostname === '127.0.0.1' || 
                     window.location.hostname.includes('dev') ||
                     window.location.hostname.includes('staging') ||
                     window.location.hostname.includes('preview') ||
                     window.location.search.includes('debug=popup') ||
                     window.location.search.includes('preview_theme_id')) &&
                     !window.location.href.includes('shopify') &&
                     window.parent === window; // Not in iframe



// Function to test geolocation with specific country (development only)
if (isDevelopment) {
	window.testGeolocation = async (countryCode = 'CH') => {
		const mockData = {
			country_code2: countryCode,
			is_eu: ['AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE', 'CH'].includes(countryCode)
		};
		
		// Find the country theme for the test country
		const countryTheme = getThemeRedirectValues().find(item => 
			item.countries.includes(countryCode.toLowerCase())
		);
		
		if (countryTheme) {
			showLocationPopup(countryTheme);
		} else {
		}
	};
}

// Check for force popup parameter (development only)
if (urlParams.get('force_popup') === 'true' && isDevelopment) {
	document.cookie = 'popupClosed=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
	showLocationPopup(window.theme.redirect.uk);
} else if (urlParams.get('show_geo') === 'true') {
	// Check for show_geo parameter (works in production too)
	document.cookie = 'popupClosed=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
	showLocationPopup(window.theme.redirect.uk);
} else if (urlParams.get('debug') === 'popup' && isDevelopment) {
	document.cookie = 'popupClosed=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
	setTimeout(() => {
		showLocationPopup(window.theme.redirect.uk);
	}, 2000);
} else if (isDevelopment) {
	// Clear any existing popup cookies for development
	document.cookie = 'popupClosed=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
	// In development, run geolocation detection to get actual location
	window.onload = getCountry;
} else if (
	urlParams.get('default') === 'yes' // Check if the user was redirected already
) {
	// Add cookies to not show the popup for a week
	addCookie(cookieDuration);
} else if (
	document.cookie.includes('popupClosed=true') || // Check if 'popupClosed' cookie is set to 'true'
	googleAdsBotUserAgents.includes(userAgent) ||
	parent.document.URL.includes('shopify') ||
	window.location.href.includes('shopify') ||
	window.location.hostname.includes('shopify') ||
	window.parent !== window // Block if in iframe (Shopify customize mode)
) {
	// Do nothing..
	} else {
		// Set up the geolocation call
		window.onload = getCountry;
	}
